import useCountryState from 'shared/hooks/useCountryState'
import { guestUserVehicleSelector } from 'manage-guest-user-booking/selectors'

import featureToggles from 'shared/featureToggles'
import { CardSection } from '@components/CardSection'
import Button from '@components/Button'
import VehicleForm from '@components/VehicleForm'

import styles from './styles.module.scss'

const INITIAL_STATE = {
    tag: '',
    make: '',
    model: '',
    color: '',
}

const VehicleFormSection = ({ onNext, setVehicle, selectVehicle, guestUserVehicle }) => {
    const initializeVehicleFormData = {
        tag: guestUserVehicle?.tag || INITIAL_STATE.tag,
        make: guestUserVehicle?.make || INITIAL_STATE.make,
        model: guestUserVehicle?.model || INITIAL_STATE.model,
        color: guestUserVehicle?.color || INITIAL_STATE.color,
    }

    const [vehicleFormData, setVehicleFormData] = React.useState(initializeVehicleFormData)
    const [isFormValid, setIsFormValid] = React.useState(false)
    const { countryStateComponent, setSelectedState, setSelectedCountry, selectedCountry, selectedState } =
        useCountryState()

    const onNextStep = () => {
        onNext()
        setVehicle([{ ...vehicleFormData, displayValue: vehicleFormData.tag }])
        selectVehicle(vehicleFormData)
    }
    React.useEffect(() => {
        if (featureToggles.caPurchaseFlow) {
            if (guestUserVehicle?.state) {
                setSelectedState(guestUserVehicle?.state)
            }
            if (guestUserVehicle?.country) {
                setSelectedCountry(guestUserVehicle.country)
            }
        }
    }, [])

    React.useEffect(() => {
        if (featureToggles.caPurchaseFlow) {
            if (selectedCountry) {
                setVehicleFormData({ ...vehicleFormData, country: selectedCountry })
            }
            if (selectedState) {
                setVehicleFormData({ ...vehicleFormData, state: selectedState })
            }
        }
    }, [])

    React.useEffect(() => {
        if (selectedState && featureToggles.caPurchaseFlow) {
            setVehicleFormData({ ...vehicleFormData, state: selectedState })
        }
    }, [selectedState])

    React.useEffect(() => {
        if (selectedCountry && featureToggles.caPurchaseFlow) {
            setVehicleFormData({ ...vehicleFormData, country: selectedCountry })
        }
    }, [selectedCountry])

    const buttonsSectionContent = block => (
        <Button onClick={onNextStep} block={block} disabled={!isFormValid}>
            <T>guest.booking.checkout.next.btn.label</T>
        </Button>
    )

    return (
        <CardSection className={styles.vehicleFormCardSection}>
            <h3 className="font-weight-bold mb-4">
                <T>booking.purchase.vehicle.label</T>
            </h3>
            <div className={styles.vehicleForm}>
                <VehicleForm
                    formValues={vehicleFormData}
                    setFormValues={setVehicleFormData}
                    countryStateComponent={countryStateComponent}
                    handleOnValid={() => setIsFormValid(true)}
                    handleOnInvalid={() => setIsFormValid(false)}
                />
            </div>
            <div className={styles.vehicleNextButton}>{buttonsSectionContent(false)}</div>
        </CardSection>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            guestUserVehicle: guestUserVehicleSelector,
        })
    )
)(VehicleFormSection)
